import React from 'react';
import { parse } from 'query-string';
import { withRouter } from 'react-router-dom';
import { Switch, Route } from 'react-router';

import LodgePayment from './Payment';
import LodgeDetails from './Details';
import { PaymentSuccess } from '../../components';
import SearchLodgesScreen from './Search';
import LodgeListingsScreen from './Listings';

import { lodgeId } from '../../constants/idRegex';

const baseRoute = `/:lodgeName.:lodgeId(${lodgeId}).:placeName-lodges`;
const paymentSuffix = 'payment/:invoiceId';
const paymentSuccessSuffix = 'payment-success';

const DetailsAndPayment = () => (
  <Switch>
    <Route exact path={baseRoute} component={LodgeDetails} />
    <Route exact path={`${baseRoute}/${paymentSuffix}`} component={LodgePayment} />
    <Route
      exact
      path={`${baseRoute}/${paymentSuffix}/${paymentSuccessSuffix}`}
      component={PaymentSuccess}
    />
  </Switch>
);

type Props = {
  location: { search: string },
};

const SearchAndListings = withRouter((props: Props) => {
  const { placeId: userHasQueriedForLodges } = parse(props.location.search);

  return userHasQueriedForLodges ? <LodgeListingsScreen /> : <SearchLodgesScreen />;
});

export { SearchAndListings, DetailsAndPayment };



// WEBPACK FOOTER //
// ./src/screens/Lodge/Home.js